import { CaseType } from '@brands/services/cases/types/ICase';
import * as yup from 'yup';

export const CASE_TYPE_OPTIONS = [
  { value: CaseType.video_call_scheduled, label: 'Scheduled video call' },
  { value: CaseType.one_report, label: 'Photo review' },
  { value: CaseType.second_opinion, label: 'Second Opinion' },
  { value: CaseType.phone_call_scheduled, label: 'Scheduled phone call' },
  { value: CaseType.clinical_enablement, label: 'Clinical Enablement' },
];

export const CASE_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  CASE_TYPE_OPTIONS.map(({ value, label }) => [value, label]),
);

export const PROVIDER_ALLOWED_CASE_TYPES = [
  'video_call_scheduled',
  'one_report',
  'phone_call_scheduled',
  'second_opinion',
  'clinical_enablement',
] as const;

export const complianceChecklistSchema = (originalCaseType: string) => {
  return yup.object({
    confirmCaseType: yup.string().oneOf(Object.keys(CASE_TYPE_LABELS)).required('Case type is required'),

    reason: yup.string().when('confirmCaseType', {
      is: (value: string) => value !== originalCaseType,
      then: (schema) => schema.required('Reason is required'),
      otherwise: (schema) => schema.notRequired(),
    }),

    otherReason: yup.string().when('reason', {
      is: 'Other',
      then: (schema) => schema.trim().required('Additional details are required'),
      otherwise: (schema) => schema.notRequired(),
    }),

    additionalPeople: yup.string().notRequired(),

    confirmChecked: yup.boolean().oneOf([true], 'You must confirm before submitting'),
  });
};
